import type React from "react";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { Table } from "~/components/common/parts/table/Table";
import { TableBody } from "~/components/common/parts/table/TableBody";
import { TableHeader } from "~/components/common/parts/table/TableHeader";
import { ImportTypeRow } from "~/components/specifics/settings/imports/ImportTypeRow";
import { useImportLogs } from "~/hooks/admin/useImportLogs";
import type { ImportType } from "~/models/ImportLog";
import { convertImportType, importTypes } from "~/models/ImportLog";
import SettingStyles from "../SettingStyle.module.scss";

export const Page: React.FC = () => {
	const { data: importLogs } = useImportLogs().useIndex();
	if (importLogs === null) {
		return null;
	}
	return (
		<DefaultV2>
			<ClientSettingLayout>
				<h2 className={SettingStyles.SettingTitle}>過去データ取込</h2>
				<Table>
					<TableHeader>
						<th>取込タイプ</th>
						<th>取込画面</th>
						<th>取込件数</th>
						<th>最終取込日時</th>
					</TableHeader>
					<TableBody>
						{importTypes.map((importType: ImportType) => (
							<ImportTypeRow
								importLogWithCount={importLogs[convertImportType(importType)]}
								importType={importType}
								key={importType}
							/>
						))}
					</TableBody>
				</Table>
			</ClientSettingLayout>
		</DefaultV2>
	);
};
